import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addNegativeToast } from 'modules/toastContainer';

import { useUserKeyLookupQueryContext } from '../contexts/UserKeyLookupQueryContext';
import { getFormStateFromLookupRequest } from '../utils/getFormStateFromLookupRequest';

const displayText = {
  error: 'User does not exist',
};

export const useErrorToastOnUnsuccessfulLookup = () => {
  const dispatch = useDispatch();
  const { isLoading, isError, query, userKey } = useUserKeyLookupQueryContext();
  const identifier = query && getFormStateFromLookupRequest(query).identifier;
  const userNotFound = !!identifier && !isLoading && (isError || !userKey);
  useEffect(() => {
    if (userNotFound) {
      dispatch(addNegativeToast(`${displayText.error}: ${identifier}`));
    }
  }, [userNotFound]);
};
